module.exports = __webpack_public_path__ + "static/media/about-icon-textile.aa41f7c6.svg";